var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00390625H513V341.989H0V-0.00390625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00390625H513V113.993H0V-0.00390625Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.991H513V341.988H0V227.991Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.974 150.979L290.953 163.354L305.495 158.638L296.502 171.002L305.481 183.375L290.943 178.641L281.95 191.006L281.96 175.718L267.421 170.983L281.964 166.268L281.974 150.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.467 201.921C240.385 201.921 226.538 188.073 226.538 170.993C226.538 153.913 240.386 140.065 257.467 140.065C262.604 140.057 267.662 141.335 272.179 143.782C265.315 137.071 255.93 132.928 245.572 132.928C224.549 132.928 207.505 149.971 207.505 170.994C207.505 192.017 224.549 209.06 245.572 209.06C255.93 209.06 265.316 204.917 272.179 198.206C267.662 200.652 262.604 201.929 257.467 201.921Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLy);
export default __webpack_public_path__ + "static/media/LY.5b9eac26e3aa723b130e73af6f12210d.svg";
export { ForwardRef as ReactComponent };